export const BRANCH_META = {
    sciences: {
        name: "Sciences",
        color: "#FF2052",
        soft: "#FFE1E9",
        text: "#8A0025",
        tagline: "Logic, data, physics, clinical",
    },
    arts: {
        name: "Arts",
        color: "#FFC107",
        soft: "#FFF3CC",
        text: "#7A5A00",
        tagline: "Design, music, film, form",
    },
    trades: {
        name: "Trades",
        color: "#3EB489",
        soft: "#DBF3E9",
        text: "#1F5D46",
        tagline: "Hands, matter, craft",
    },
    humanities: {
        name: "Humanities",
        color: "#6F00FF",
        soft: "#EADEFF",
        text: "#390089",
        tagline: "Words, history, law, mind",
    },
    business: {
        name: "Business",
        color: "#1E88E5",
        soft: "#DCEBFC",
        text: "#0D3D75",
        tagline: "Ventures, finance, product, growth",
    },
};

export const BRANCH_ORDER = ["sciences", "arts", "trades", "humanities", "business"];

export function branchColor(slug) {
    return BRANCH_META[slug]?.color || "#0F172A";
}

export function branchSoft(slug) {
    return BRANCH_META[slug]?.soft || "#F1F5F9";
}
